import Switch from '@mui/material/Switch'
import NoDataImg from '../../../assets/img/no-data.gif'
import { EditBeads } from './EditBeads'
import { v4 as uuidv4 } from 'uuid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Fragment, useEffect, useState, useRef } from 'react' // ranith 2025-12-06 - [Start] - [Import useRef]
import { showDangerToast, showToast } from '../../constants/toaster'
import { ViewUser } from './ViewUser'
import { useDispatch, useSelector } from 'react-redux'
import {
  uplodateLoading,
  updateUsers,
  clearUsersCache,
  updateSingleUserStatus,
  updateSingleUserCelebrity,
  updateSingleUserGrade,
  updateSingleUserBeads
} from '../../../redux/features/common/commonSlice'
import {
  selectUsersPages,
  selectUsersIsLoaded,
  selectUsersPagerecord
} from '../../../redux/features/common/selectors'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import Pagination from '@mui/material/Pagination'
import { Link, useLocation, useSearchParams, useNavigate } from 'react-router-dom' // Added useSearchParams and useNavigate
import { InvitedUserModal } from './InvitedUserModal';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Button from '@mui/material/Button';
import GradeUpdateModal from './GradeUpdateModal';
import './style.css'
import { formatIndianNumber } from '../../lib/formatIndianNumber'
import dayjs from 'dayjs'

const toApiDateAtMidnight = (dateValue) => {
  if (!dateValue) return ''
  return `${dayjs(dateValue).startOf('day').format('YYYY-MM-DD')}T00:00:00.000Z`
}

/** Backend already formats createdAt as IST (`yyyy-MM-dd HH:mm:ss`). Format wall-clock as-is (no TZ re-shift). */
const formatCreatedAtIst = (createdAt) => {
  if (!createdAt) return ''
  const match = String(createdAt).match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/
  )
  if (match) {
    const [, year, month, day, hourStr, minute] = match
    const hour = Number(hourStr)
    const ampm = hour >= 12 ? 'PM' : 'AM'
    const hour12 = hour % 12 || 12
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    return `${months[Number(month) - 1]} ${Number(day)}, ${year}, ${hour12}:${minute} ${ampm}`
  }
  const value = dayjs(createdAt)
  return value.isValid() ? value.format('MMM D, YYYY, h:mm A') : ''
}

const label = { inputProps: { 'aria-label': 'Size switch demo' } }
const isDefaultFilter = (fd) => {
  if (!fd) return true;
  return (
    !fd.searchText &&
    !fd.contactNumber &&
    !fd.accountStatus &&
    !fd.startDate &&
    !fd.endDate &&
    !fd.subscription &&
    !fd.kycStatus &&
    fd.isGrade === null
  );
};

export const NormalUserTable = props => {
  const [callAPi, setCallAPi] = useState(null)
  const latestRequestRef = useRef(0)
  const [showEditBead, setShowEditBead] = useState(false)
  const [userId, setUserId] = useState()
  const [userBalance, setUserBalance] = useState(0)
  const [showViewUserDetails, setShowViewUserDetails] = useState(false)

  const [sort_type, setSortType] = useState('createdAt')
  const [sort_order, setSortOrder] = useState(false)
  const userData = useSelector(state => state?.userData)
  const [localDatalist, setLocalDatalist] = useState([])
  const dispatch = useDispatch()
  // Use URL query parameters instead of location.state for persistence across refreshes
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const initialPage = parseInt(searchParams.get('page')) || 1;
  const initialPageSize = parseInt(searchParams.get('pageSize')) || 25;

  const [page, setPage] = useState(initialPage)
  const [listLoading, setListLoading] = useState(false)
  const [pendingUpdates, setPendingUpdates] = useState(null)
  const [showInvitedUserListModal, setShowInvitedUserListModal] = useState(false)
  const [selectedReferralCode, setSelectedReferralCode] = useState('')
  const [localPagerecord, setLocalPagerecord] = useState({
    totalItems: 0,
    pageNumber: initialPage,
    pageSize: initialPageSize,
    isGrade: null,

    totalPages: 1
  })

  const isCacheable = !props.referralCode && isDefaultFilter(props?.filterData) && (localPagerecord.pageSize === 25 || !localPagerecord.pageSize);
  const isCacheablePage = isCacheable && (page === 1 || page === 2);

  const pages = useSelector(selectUsersPages)
  const reduxPagerecord = useSelector(selectUsersPagerecord)

  const datalist = isCacheablePage ? (pages[page] || []) : localDatalist;
  const pagerecord = isCacheablePage ? reduxPagerecord : localPagerecord;
  // ranith 2025-12-06 - [End] - [Initialize state from location]
  const [pageSizeInput, setPageSizeInput] = useState(25);
  useEffect(() => {
    setPageSizeInput(pagerecord.pageSize);
  }, [pagerecord.pageSize]); // This runs when pageSize changes

  // --- NEW ---
  // This function just updates the temporary input text
  const handlePageSizeInputChange = (e) => {
    setPageSizeInput(e.target.value);
  };

  // --- NEW ---
  // This function validates and calls the API
  const handlePageSizeSubmit = () => {
    let val = Number(pageSizeInput);

    // Validate the input
    if (val < 1 || isNaN(val)) {
      val = 25; // Revert to default
    } else if (val > 50) {
      val = 50;
    }

    // Update the input field to show the validated number
    setPageSizeInput(val);

    // Only call the API if the page size is actually changing
    if (val !== pagerecord.pageSize) {
      // ranith 2025-12-06 - [Start] - [Preserve list position on page size change]
      // Calculate the index of the first item currently visible
      const currentFirstItemIndex = (page - 1) * pagerecord.pageSize;
      // Calculate the new page number that contains this item
      const newPage = Math.floor(currentFirstItemIndex / val) + 1;

      // Update state with the new page number
      setLocalPagerecord(prev => ({ ...prev, pageNumber: newPage, pageSize: val }));
      setPage(newPage);
      setPageInput(newPage);

      // Update URL query parameters
      const params = new URLSearchParams(searchParams)
      params.set('page', String(newPage))
      params.set('pageSize', String(val))
      navigate(`?${params.toString()}`, { replace: true });

      dispatch(clearUsersCache())
      setCallAPi(uuidv4());
      // ranith 2025-12-06 - [End] - [Preserve list position on page size change]
    }
  };
  // ... right after your other useState hooks
  const totalPages = pagerecord?.totalPages || 1;  // ✅ define here, once


  const [pageInput, setPageInput] = useState(page);
  useEffect(() => {
    setPageInput(page); // keep input in sync with actual page
  }, [page]);

  const handlePageInputChange = (e) => {
    setPageInput(e.target.value);
  };


  const handlePageInputSubmit = () => {
    const value = Number(pageInput);
    if (value >= 1 && value <= totalPages) {
      handleChange(null, value); // update actual pagination
    } else {
      setPageInput(page); // reset if invalid
    }
  };

  const [edit, setEdit] = useState(false)
  const [active, setActive] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const [view, setView] = useState(false)
  const [inviteType, setInviteType] = useState(null)

  const userPermisiions = useSelector(state => state?.permission)
  let currentModulePermission;
  let viewPermission = true;
  let editPermission = true;
  let deletePermissionVal = true;
  let activePermission = true;

  if (userPermisiions?.modules?.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => {
      if (element.moduleId === '4') {
        return element
      }
    })?.permissions

    // ranith 2025-12-06 - [Start] - [Null Safety Fixes]
    // [Old Code Commented Out]
    /*
    // viewPermission = currentModulePermission.find((element) => {
    //   if (element.name === 'VIEW') {
    //     return element
    //   }
    // }).isEnable
    // editPermission = currentModulePermission.find((element) => {
    //   if (element.name === 'EDIT') {
    //     return element
    //   }
    // }).isEnable
    // deletePermissionVal = currentModulePermission.find((element) => {
    //   if (element.name === 'DELETE') {
    //     return element
    //   }
    // }).isEnable
    // activePermission = currentModulePermission.find((element) => {
    //   if (element.name === 'ACTIVE') {
    //     return element
    //   }
    // }).isEnable
    */

    // [New Code]
    // viewPermission = currentModulePermission?.find((element) => element.name === 'VIEW')?.isEnable ?? true;
    // editPermission = currentModulePermission?.find((element) => element.name === 'EDIT')?.isEnable ?? true;
    // deletePermissionVal = currentModulePermission?.find((element) => element.name === 'DELETE')?.isEnable ?? true;
    // activePermission = currentModulePermission?.find((element) => element.name === 'ACTIVE')?.isEnable ?? true;
    // ranith 2025-12-06 - [End] - [Null Safety Fixes]
  }
  //  console.log(currentModulePermission,'userPermisiions,rolelist,user',editPermission)

  const handleStatusChange = async (event, id) => {
    const currentItem = datalist.find(item => item.id === id)
    const currentActive = currentItem ? currentItem.active : false
    try {
      let path = urls.userActiveInActive + "/" + id;
      let res = await ApiCaller.put({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status == 200) {
        showToast(response?.message)
        dispatch(updateSingleUserStatus({ id, active: !currentActive }))
        getUserList(true)
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    }
  };
  const handleCelebrityChange = async val => {
    const id = val?.id
    const currentBadged = val?.badged || false
    try {
      let path = urls.userCelebrityStatusChange + '/' + id
      let res = await ApiCaller.put({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        showToast(response?.message)
        dispatch(updateSingleUserCelebrity({ id, badged: !currentBadged }))
        getUserList(true)
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleChange = (event, value) => {
    setPage(value)
    setLocalPagerecord(prev => ({
      ...prev,
      pageNumber: value
    }))

    // Update URL query parameters
    const params = new URLSearchParams(searchParams)
    params.set('page', String(value))
    params.set('pageSize', String(pagerecord.pageSize || 25))
    navigate(`?${params.toString()}`, { replace: true });

    setCallAPi(uuidv4())
  }

  const submitEditBeads = (userIdVal, amountVal, isDebit) => {
    setShowEditBead(false)
    showToast('Beads Update Successfully.')
    dispatch(updateSingleUserBeads({ userId: userIdVal, beads: amountVal, debitType: isDebit }))
    getUserList(true)
  }

  useEffect(() => {
    setCallAPi(uuidv4())
  }, [])

  useEffect(() => {
    if (!props.callAPiCallBack) return

    setPage(1)
    setLocalPagerecord(prev => ({
      ...prev,
      pageNumber: 1,
      isGrade: null
    }))
    const params = new URLSearchParams(searchParams)
    params.set('page', '1')
    params.set('pageSize', String(pagerecord.pageSize || 25))
    navigate(`?${params.toString()}`, { replace: true })
    dispatch(clearUsersCache())
    setCallAPi(uuidv4())
  }, [props?.callAPiCallBack])

  useEffect(() => {
    if (!callAPi) return
    getUserList()
  }, [callAPi])


  const getUserList = async (silent = false) => {
    const requestId = ++latestRequestRef.current
    const showLocalLoader = !silent && (!isCacheablePage || !pages[page]);

    if (showLocalLoader) {
      setListLoading(true)
    }

    try {
      const startDateObject = toApiDateAtMidnight(props?.filterData?.startDate)
      const endDateObject = toApiDateAtMidnight(props?.filterData?.endDate)
      const contactNumber = props?.filterData?.contactNumber?.trim()
      let postJson = {
        searchText: props?.filterData?.searchText?.trim(),
        ...(contactNumber ? { contactNumber } : {}),
        active:
          props?.filterData?.accountStatus === 'Active'
            ? true
            : props?.filterData?.accountStatus === 'In Active'
              ? false
              : '',
        subscription: props?.filterData?.subscription,
        kycStatus: props?.filterData?.kycStatus,
        isGrade: props?.filterData?.isGrade,
        pageNumber: page - 1 || 0,
        pageSize: localPagerecord.pageSize || 25,
        shortingField: sort_type,
        asc: props?.filterData?.isGrade === false ? true : sort_order,
        paid: false,
        startDate: startDateObject,
        endDate: endDateObject,
      }
      let path = urls.userList
      let res = await ApiCaller.post(postJson, path, userData?.access_token)

      const response = await res.response.json()
      if (requestId !== latestRequestRef.current) return

      if (response.status == 200) {
        const items = response?.data?.response?.items || []
        const newPagerecord = {
          totalItems: response?.data?.response?.totalItems,
          totalPages: response?.data?.response?.totalPages,
          pageNumber: page,
          pageSize: localPagerecord.pageSize || 25,
          isGrade: localPagerecord?.isGrade,
        }
        response?.data?.permissionList.forEach((module, moduleIndex) => {
          if (module.permissionName === 'EDIT') {
            setEdit(module.isEnable)
          } else if (module.permissionName === 'ACTIVE') {
            setActive(module.isEnable)
          } else if (module.permissionName === 'DELETE') {
            setDeletePermission(module.isEnable)
          } else if (module.permissionName === 'VIEW') {
            setView(module.isEnable)
          }
        })

        if (silent && isCacheablePage) {
          const cachedList = pages[page] || []
          const hasChanges = items.length !== cachedList.length || items.some((item, idx) => {
            const cachedItem = cachedList[idx]
            return !cachedItem || 
                   cachedItem.id !== item.id || 
                   cachedItem.active !== item.active || 
                   cachedItem.badged !== item.badged || 
                   cachedItem.gradeId !== item.gradeId ||
                   cachedItem.balance !== item.balance;
          })
          if (hasChanges) {
            setPendingUpdates({ pageNumber: page, datalist: items, pagerecord: newPagerecord })
          } else {
            setPendingUpdates(null)
          }
        } else {
          if (isCacheablePage) {
            dispatch(updateUsers({ pageNumber: page, datalist: items, pagerecord: newPagerecord }))
          } else {
            setLocalDatalist(items)
            setLocalPagerecord(newPagerecord)
          }
          setPendingUpdates(null)
        }
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      if (requestId !== latestRequestRef.current) return
      console.error(error)
      showDangerToast(error.message)
    } finally {
      if (requestId === latestRequestRef.current) {
        setListLoading(false)
      }
    }
  }


  // --- NEW: Function to handle Excel export ---
  const exportToExcel = () => {
    if (!datalist || datalist.length === 0) {
      showDangerToast("No data to export");
      return;
    }

    // 1. Format the data to match your table structure
    // This creates a new array with user-friendly headers
    const formattedData = datalist.map(data => ({
      "User ID": data?.userId ? data.userId.toString().padStart(8, '0') : '',
      "Registered Date": data?.createdAt ? formatCreatedAtIst(data?.createdAt) : '',
      "User Name": data?.userName,
      "Ref-By": data?.fromReferral?.trim() || '—',
      "Grade": data?.gradeName ?? '--',
      "contactNumber": `${data?.contactNumber || ''}`,
      "email": `${data?.email || ''}`,
      "Total Chips": formatIndianNumber(data?.balance),
      "Total Followers": data?.followers,
      "Total Likes": data?.likes,
      "Total Videos": data?.videos,
      "Total Subscribers": data?.subscribers,
      "Approve Video Count": data?.approvedVideoCount,
      "Total Views": data?.totalViews,
      "Total Earned": formatIndianNumber(data?.rewardChipsBalance),
      "Status": data?.active ? "Active" : "In Active",
      "Badge": data?.badged ? "Yes" : "No"
    }));

    // 2. Create worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Users"); // "Users" is the sheet name

    // 3. Generate the binary string
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

    // 4. Helper function to convert string to ArrayBuffer
    const s2ab = (s) => {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    };

    // 5. Create Blob and trigger download
    const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });
    saveAs(blob, 'UserData.xlsx'); // This is the file name
  };


  // Add these states
  const [showGradeModal, setShowGradeModal] = useState(false);
  const [selectedUserForGrade, setSelectedUserForGrade] = useState(null);

  // Open Modal
  const handleGradeClick = (user) => {
    setSelectedUserForGrade(user);
    setShowGradeModal(true);
  };

  const handleGradeUpdateSuccess = (newGradeId, newGradeName) => {
    if (isCacheablePage) {
      dispatch(updateSingleUserGrade({ id: selectedUserForGrade.id, gradeId: newGradeId, gradeName: newGradeName }))
    } else {
      const updatedList = localDatalist.map(user => {
        if (user.id === selectedUserForGrade.id) {
          return {
            ...user,
            gradeId: newGradeId,
            gradeName: newGradeName
          };
        }
        return user;
      });
      setLocalDatalist(updatedList);
    }
    getUserList(true)
    setShowGradeModal(false);
  };
  return (
    <>
      {pendingUpdates && pendingUpdates.pageNumber === page && (
        <div className="alert alert-info d-flex justify-content-between align-items-center mb-3 text-dark mx-4" style={{ borderRadius: '8px', borderLeft: '5px solid #11cdef' }}>
          <span>New user updates are available for this page.</span>
          <Button 
            variant="contained" 
            color="info" 
            size="small" 
            onClick={() => {
              if (isCacheablePage) {
                dispatch(updateUsers(pendingUpdates));
              } else {
                setLocalDatalist(pendingUpdates.datalist);
                setLocalPagerecord(pendingUpdates.pagerecord);
              }
              setPendingUpdates(null);
            }}
          >
            Update View
          </Button>
        </div>
      )}
      <div className='table-responsive'>
        {datalist?.length ? (
          <>
            <table className='table align-items-center table-flush'>
              <thead className='thead-dark text-white  bg-dark'>
                <tr className='text-white text-center  bg-dark'>
                  <th scope='col' className='text-white text-center' style={{ width: '5%' }} >S.No</th>
                  <th scope='col' className='text-white text-center' style={{ width: '10%' }} >User ID</th>
                  <th scope='col' className='text-white text-center' style={{ width: '15%' }} >User Name</th>
                  <th scope='col' className='text-white text-center' style={{ width: '2%' }} >Grade</th>
                  <th scope='col' className='text-white text-center' style={{ width: '10%' }} >Contacts</th>
                  {/* <th scope='col' className='text-white text-center'>Registered Date</th>
                  <th scope='col' className='text-white text-center'>Total Chips</th>
                  <th scope='col' className='text-white text-center'>Total Followers</th>
                  <th scope='col' className='text-white text-center'>Total Likes</th> */}
                  <th scope='col' className='text-white text-center' style={{ width: '10%' }} >Total Videos</th>
                  {/* <th scope='col' className='text-white text-center'>Total Subscribers</th>
                  <th scope='col' className='text-white text-center'>Approve Video Count</th> */}
                  <th scope='col' className='text-white text-center' style={{ width: '5%' }} >Status</th>
                  <th scope='col' className='text-white text-center' style={{ width: '5%' }} >Badge</th>
                  <th scope='col' className='text-white text-center' style={{ width: '10%' }} >Actions</th>
                </tr>
              </thead>
              <tbody>
                {datalist?.map((data, i) => {
                  // put this inside NormalUserTable, before return
                  // const totalPages = pagerecord?.totalPages || 1;

                  return (
                    <Fragment key={i}>
                      <tr style={{ height: datalist?.length === 1 ? '120px' : 'auto' }}>
                        {/* ranith 2025-12-06 - [Start] - [Null Safety Fixes] */}
                        {/* [Old Code Commented Out] */}
                        {/* <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + i + 1}</td> */}

                        {/* [New Code] */}
                        <td>{((pagerecord?.pageNumber || 1) - 1) * (pagerecord?.pageSize || 25) + i + 1}</td>
                        {/* ranith 2025-12-06 - [End] - [Null Safety Fixes] */}
                        <td className='user-id-cell'>
                          <div className='user-id-cell__id'>
                            {data?.userId ? data?.userId.toString().padStart(8, '0') : '—'}
                          </div>
                          <div className='user-id-cell__date text-muted'>
                            {data?.createdAt ? formatCreatedAtIst(data.createdAt) : '—'}
                          </div>
                        </td>
                        <td className='user-name-cell'>
                          <Link
                            className='dropdown-item text-primary text-underline h5 user-name-cell__link'
                            to={`/user-manager/${data?.id}`}
                            target='_blank'
                            state={{ page: page, pageSize: pagerecord.pageSize }}
                          >
                            {data?.userName}
                          </Link>
                          {data?.fromReferral?.trim() ? (
                            <div className='user-name-cell__referral text-muted'>
                              <span>Ref-By:</span>{' '}
                              <span>{data.fromReferral.trim()}</span>
                            </div>
                          ) : null}
                        </td>
                        <td className=''>
                          <div
                            className='bg-secondary rounded text-center text-white p-2 h5'
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleGradeClick(data)}
                          >
                            {/* This will now auto-update because we updated datalist */}
                            {data?.gradeName ?? '+ Assign'}
                            <i className="fas fa-pen ml-1" style={{ fontSize: '10px' }}></i>
                          </div>
                        </td>
                        <td>

                          {data?.contactNumber}
                          <br></br>

                          {data?.email}


                        </td>
                        {/* <td>{formatDate(data?.createdAt)}</td>
                        <td ><div className=' bg-warning rounded text-center text-white p-2 h5' >
                          {data?.balance?.toFixed(2)}</div></td>
                        <td><div className=' bg-success rounded text-center text-white p-2 h5' >{data?.followers}</div></td>
                        <td><div className=' bg-danger rounded text-center text-white p-2 h5' > {data?.likes}</div></td> */}
                        <td> <div className=' bg-info rounded text-center text-white p-2 h5' >  {data?.videos} </div></td>
                        {/* <td> <div className=' bg-theme-color rounded text-center text-white p-2 h5' >  {data?.subscribers} </div> </td>
                        <td>  <div className=' bg-indigo rounded text-center text-white p-2 h5' >  {data?.approvedVideoCount} </div> </td> */}
                        <td>
                          {/* ranith 2025-12-06 - [Start] - [Null Safety Fixes] */}
                          {/* [Old Code Commented Out] */}
                          {/* {userData.admin ? ( */}

                          {/* [New Code] */}
                          {userData?.admin ? (
                            // ranith 2025-12-06 - [End] - [Null Safety Fixes]
                            <Switch
                              {...label}
                              checked={data?.active}
                              onChange={(e) => {
                                handleStatusChange(e, data?.id)
                              }
                              }
                              size='small'
                            />
                          ) : viewPermission ? (
                            <Switch
                              {...label}
                              disabled={!activePermission}
                              checked={data?.active}
                              onChange={(e) => {
                                if (activePermission) {
                                  handleStatusChange(e, data?.id)
                                }
                              }
                              }
                              size='small'
                            />
                          ) : (
                            <></>
                          )}
                        </td>
                        <td>
                          <Switch
                            {...label}
                            checked={data?.badged}
                            disabled={!editPermission}
                            onChange={e => {
                              if (editPermission) {
                                handleCelebrityChange(data)
                              }
                            }}
                            size='small'
                          />
                        </td>
                        <td className='text-right'>
                          <div className='dropdown'>
                            <a
                              className='btn btn-sm btn-icon-only text-dark'
                              role='button'
                              data-toggle='dropdown'
                              aria-haspopup='true'
                              aria-expanded='false'
                            >
                              <i className='fas fa-ellipsis-v' />
                            </a>
                            <div
                              className='dropdown-menu dropdown-menu-right dropdown-menu-arrow'
                              x-placement='bottom-end'
                              style={{
                                position: 'absolute',
                                willChange: 'transform',
                                top: '0px',
                                left: '0px',
                                transform: 'translate3d(32px, 32px, 0px)'
                              }}
                            >
                              {
                                editPermission &&
                                <a
                                  className='dropdown-item cursor'
                                  onClick={() => {
                                    setShowEditBead(true)
                                    setUserBalance(data?.balance)
                                    setUserId(data?.userId)
                                  }}
                                >
                                  Edit
                                </a>
                              }
                              <Link
                                className='dropdown-item'
                                to={`/user-manager/${data?.id}`}
                                target='_blank'
                                // ranith 2025-12-06 - [Start] - [Pass page state]
                                state={{
                                  page: page,
                                  pageSize: pagerecord.pageSize,
                                  referralCode: data?.referralCode,
                                  cashReferralCode: data?.cashReferralCode,
                                }}
                              // ranith 2025-12-06 - [End] - [Pass page state]
                              // onClick={e => setShowViewUserDetails(true)}
                              >
                                View
                              </Link>
                              <a
                                className='dropdown-item'
                                onClick={e => {
                                  setShowInvitedUserListModal(true)
                                  setSelectedReferralCode(data?.referralCode)
                                  setInviteType(null) // <-- clear for normal invite
                                }}
                              >
                                View Invited Users
                              </a>
                              {/* Creator invited users — disabled
                              <a
                                className='dropdown-item'
                                onClick={e => {
                                  setShowInvitedUserListModal(true);
                                  setSelectedReferralCode(data?.cashReferralCode || data?.referralCode)
                                  setInviteType("CREATERINVITE")
                                }}
                              >
                                View creater Invited Users
                              </a>
                              */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </Fragment>
                  )
                })}
              </tbody>
            </table>
            {/* Place the Modal Component here */}
            <GradeUpdateModal
              show={showGradeModal}
              onHide={() => setShowGradeModal(false)}
              userId={selectedUserForGrade?.id}
              userName={selectedUserForGrade?.userName}
              currentGradeId={selectedUserForGrade?.gradeId} // Pass existing ID
              onSuccess={handleGradeUpdateSuccess}
            />
          </>
        ) : (
          <>
            <div className='text-center'>
              <img width={'25%'} src={NoDataImg}></img>
              <br />
              <label style={{ fontWeight: 'bold' }}>
                {listLoading ? <>Loading Data.....</> : <>No Data Found</>}
              </label>
            </div>
          </>
        )}
        <EditBeads
          show={showEditBead}
          userId={userId}
          balance={userBalance}
          onSubmit={() => submitEditBeads()}
          onHide={() => setShowEditBead(false)}
        />

        <InvitedUserModal
          show={showInvitedUserListModal}
          referralCode={selectedReferralCode}
          inviteType={inviteType} // <-- pass here
          onHide={() => setShowInvitedUserListModal(!showInvitedUserListModal)}
        />
        <ViewUser
          show={showViewUserDetails}
          userId={userId}
          onHide={() => setShowViewUserDetails(false)}
        />
      </div>
      {datalist && datalist.length > 0 ? (
        <div className='card-footer py-4'>


          <Box display='flex' justifyContent='right' alignItems='center'>
            <Button
              variant="contained"
              onClick={exportToExcel}
              disabled={!datalist || datalist.length === 0}
              sx={{ mr: 2, mb: { xs: 1, sm: 0 } }}
            >
              Export to Excel
            </Button>
            <TextField
              label="Page Size"
              type="number"
              inputProps={{ min: 1, max: 50 }}
              value={pageSizeInput}
              onChange={handlePageSizeInputChange}
              onBlur={handlePageSizeSubmit}
              onKeyDown={(e) => e.key === "Enter" && handlePageSizeSubmit()}
              size="normal"
              sx={{ mr: 2, width: 140 }}
            />
            <span>Total record: {pagerecord?.totalItems}</span>
            <TextField
              label="Go to page"
              type="number"
              inputProps={{ min: 1, max: totalPages }}
              value={pageInput}
              onChange={handlePageInputChange}
              onBlur={handlePageInputSubmit}   // validate on blur
              onKeyDown={(e) => e.key === "Enter" && handlePageInputSubmit()} // validate on Enter
              size="normal"
              sx={{ mx: 2 }}
            />
            <Pagination
              className='custom-pagination-class h5'
              count={pagerecord?.totalPages}
              page={page}
              onChange={handleChange}
              color='secondary'

            />
          </Box>

        </div>
      ) : (
        <></>
      )}
    </>
  )
}
